
import { CanonicalBookMap } from '../canonicalBookMap';

export default {
  /* Biology 1e */ '185cbf87-c72e-48f5-b51e-f14f21b5eabd' : [
    /* Biology 2e */ ['8d50a0af-948b-4204-a71d-4826cba765b8', {
      /* Preface to the same module in 2e */
      '7d501ff3-7b18-4b9e-99fd-2f596024f3a1': 'db36053c-5281-42f4-90ec-afcc21ab28c3',
      /* 1.0 Introduction to the same module in 2e */
      'ad9b9d37-a5cf-4a0d-b8c1-083fcc4d3b0c': '2230ab90-3137-4dcb-b6bd-72630222948c',
      /* 1.1 The Science of Biology to the same module in 2e */
      '6a0568d8-23d7-439b-9a01-16e4e73886b3': 'ce6cfde4-1ac3-480f-aa0f-4777111f9e23',
      /* 1.2 Themes and Concepts of Biology to the same module in 2e */
      '80d2e9ef-abee-40c2-8586-5459a67c81f3': '07dbec85-8530-4911-b863-5d73b5d7e211',
      /* 2.0 Introduction to the same module in 2e */
      '7636a3bf-eb80-4898-8b2c-e81c1711b99f': '28a88cb8-e0d5-44df-8ad2-6e54a2ed3792',
      /* 2.1 Atoms, Isotopes, Ions, and Molecules: The Building Blocks to the same module in 2e */
      'be8818d0-2dba-4bf3-859a-737c25fb2c99': 'c555a265-6305-4b1a-be14-c4b1e853ac89',
      /* 2.2 Water to the same module in 2e */
      'a4f8df82-c778-4971-8dcc-7c5c72578e94': '7e2d0dde-7b2f-48e6-bbf6-f3dacbe4ce9d',
      /* 2.3 Carbon to the same module in 2e */
      '52bfe5d1-7f8a-49b1-9c47-973d3f518958': '3ff875dd-6bd4-4911-80eb-37b5f7ae2f8f',
      /* 3.0 Introduction to the same module in 2e */
      'ee61d395-bee6-4692-8f3d-42159c445365': '5d980d41-8d3a-46ca-94b1-86444c438e2d',
      /* 3.1 Synthesis of Biological Macromolecules to the same module in 2e */
      'ea44b8fa-e7a2-4360-ad34-ac081bcf104f': '4acfa729-2ba0-4675-ac7d-1f3e8c0434f2',
      /* 3.2 Carbohydrates to the same module in 2e */
      '73b3ac54-811c-4bce-a9dd-e83f8c0dda77': 'a4a9af98-26dd-4c80-b267-6309ecfc0bae',
      /* 3.3 Lipids to the same module in 2e */
      '23ff3343-6924-4c37-8a08-876db2e9e242': '950a56b9-0188-4845-a108-a982ead0b168',
      /* 3.4 Proteins to the same module in 2e */
      'db3ce6d5-01bd-4ac5-a641-de285fdac0f1': '211c8917-4044-4b0e-980c-0a84a86a48b0',
      /* 3.5 Nucleic Acids to the same module in 2e */
      'cb178029-ce17-4c82-aa11-94a2acf4accf': '10601b75-87ce-40d7-9e5b-fe1bdbd0e13f',
      /* 4.0 Introduction to the same module in 2e */
      'e98bdaec-4060-4b43-ac70-681555a30e22': '64d85e3f-cd5a-40ef-bfe3-7b19b6622f76',
      /* 4.1 Studying Cells to the same module in 2e */
      '003aedba-f354-4e57-ba45-f8b4eda66e12': 'ee83926c-c622-4c46-ba10-94144cfb09e1',
      /* 4.2 Prokaryotic Cells to the same module in 2e */
      'a4ea5574-8c29-4a6d-a9af-3301ed2fdaa0': '1926a985-c22b-4e1b-9e74-9acad31dc1b0',
      /* 4.3 Eukaryotic Cells to the same module in 2e */
      '14f17ea6-1853-4b32-a834-576eb6dfeb67': '2ec76ad2-c275-4b81-9168-244ef063caee',
      /* 4.4 The Endomembrane System and Proteins to the same module in 2e */
      '10b53780-2949-45e7-961b-aafefeec467a': '62cac3b7-6fa8-4cef-921d-4da0dc770600',
      /* 4.5 The Cytoskeleton to the same module in 2e */
      '736d0748-2d71-4db3-90bd-16ef0a9ad64d': '32bc121f-bdb5-4db6-b65f-de5a90752e57',
      /* 4.6 Connections between Cells and Cellular Activities to the same module in 2e */
      'f14ca9c7-bbee-4ea2-ac54-b0a3c6d4bda7': '6bf6f287-e4f5-43bc-b861-7392e93db397',
      /* 5.0 Introduction to the same module in 2e */
      'a1a2f03a-701f-4e7a-ae0e-d8087880c6fd': '13e0e95a-8a94-49de-947d-beedb3062923',
      /* 5.1 Components and Structure to the same module in 2e */
      '40e1947a-5a8b-4314-a9e7-bae3cedb885d': 'b646317c-8aae-4962-b0a3-5519d34d35e5',
      /* 5.2 Passive Transport to the same module in 2e */
      'e97f68fb-49fa-47ba-875b-6b1d59d8f11b': 'c72e42de-7fe3-4645-8e14-67e79dd6edbc',
      /* 5.3 Active Transport to the same module in 2e */
      '0a64c993-2b3c-4cd6-94f8-1d864df896ce': '6e5bb14c-2d99-4427-87c6-0f8d34e55cbd',
      /* 5.4 Bulk Transport to the same module in 2e */
      '1f0bcd44-86e1-4c34-af1e-3de348baa8d4': '82b417e1-6471-4c85-9d31-909eef7296b5',
      /* 6.0 Introduction to the same module in 2e */
      '77d140f0-5582-48ad-9119-79bdb81fbc70': '8920972b-8dbb-4791-9603-f857cf254d78',
      /* 6.1 Energy and Metabolism to the same module in 2e */
      'ed5df737-77ff-452c-b91e-a2c2dad59606': 'cd16b4c2-bfec-4720-a816-4c01bd448f63',
      /* 6.2 Potential, Kinetic, Free, and Activation Energy to the same module in 2e */
      '16b284a1-de63-4e08-910a-8baf1b94fc1e': '7c27bd5e-7ad6-466c-b204-4d46bd7a60a9',
      /* 6.3 The Laws of Thermodynamics to the same module in 2e */
      '1d93a84f-d3e4-498b-99fb-36f389084856': '071bb27f-a14e-43ea-8301-4447cec95b7a',
      /* 6.4 ATP: Adenosine Triphosphate to the same module in 2e */
      '99c09a74-d755-47ec-a38d-f6cc1aa5a6a7': 'bf373df5-f10e-486d-ba9b-f6cf58f8a45b',
      /* 6.5 Enzymes to the same module in 2e */
      '3270ba1a-e262-481e-9902-61ef811251d5': '0c2a7c48-3b37-42de-96f5-df9876da7033',
      /* 7.0 Introduction to the same module in 2e */
      'e5cf99b1-c357-48c0-bd05-e15557c89951': 'ee613999-8e35-4d65-a1f9-4c5e908cd77e',
      /* 7.1 Energy in Living Systems to the same module in 2e */
      '75fabe48-5fbc-458b-9062-010dd3886ae5': 'ea06569f-1c57-48cc-9b4a-823e0cf298ef',
      /* 7.2 Glycolysis to the same module in 2e */
      'b58b6923-aad7-4c62-907e-fb0c0ba08f44': '1dc8fdc5-8378-46b7-9bf0-013313899fa3',
      /* 7.3 Oxidation of Pyruvate and the Citric Acid Cycle to the same module in 2e */
      'c1e00705-ab75-4c24-8c6c-5d983c3cca49': '0de580e3-70bc-4ee4-bc54-fe120f6ef827',
      /* 7.4 Oxidative Phosphorylation  to the same module in 2e */
      'ee84d502-0ad9-4abb-a530-94252d9f08d9': '1138cd07-0f3c-4e2f-a077-f567a96550de',
      /* 7.5 Metabolism without Oxygen to the same module in 2e */
      '8e609899-8a25-47cd-a019-11ed0e065755': 'bf4afd26-edbc-4377-bbd8-a137c87b2968',
      /* 7.6 Connections of Carbohydrate, Protein, and Lipid Metabolic Pathways to the same module in 2e */
      '64fe39ec-5eb8-491e-93ba-a92598aaaa80': '2b456a61-aaa0-4218-8f4a-e5bbe96e7f45',
      /* 7.7 Regulation of Cellular Respiration to the same module in 2e */
      'cd121ae8-7896-4d46-a606-17f78c37b826': 'f4a54a19-7e8c-4d10-b7ac-4c533251b307',
      /* 8.0 Introduction to the same module in 2e */
      '48242857-59d1-4b46-a7e2-f27c33299f56': '50212ab1-bb1d-4a88-9ca3-b6807a6c3e56',
      /* 8.1 Overview of Photosynthesis to the same module in 2e */
      '5bb72d25-e488-4760-8da8-51bc5b86c29d': '7440ee65-14ae-4496-acf0-c03fa8f65ed2',
      /* 8.2 The Light-Dependent Reactions of Photosynthesis  to the same module in 2e */
      'f829b3bd-472d-4885-a0a4-6fea3252e2b2': 'c1b3c21b-fa66-4636-aa58-507f60ee7663',
      /* 8.3 Using Light Energy to Make Organic Molecules to the same module in 2e */
      '36b3469d-e561-44ff-ac32-99f4d18830e2': '5450dd2d-7ae4-4693-b154-21f0e9bfac66',
      /* 9.0 Introduction to the same module in 2e */
      'd5ef65df-70bb-4cd6-8377-4c0f315c9e97': '8e7669be-5c01-4e67-bf43-c502a87c12bc',
      /* 9.1 Signaling Molecules and Cellular Receptors to the same module in 2e */
      '1f8a0ca4-24a2-44fd-9706-f43ac0a5904e': 'ae7b3cf8-19e4-455c-ad16-428a55153eed',
      /* 9.2 Propagation of the Signal to the same module in 2e */
      'b13912c1-d7fb-4f5f-9b8a-04a0ee9ed00f': 'cf893f8d-360e-40b4-89d0-c63cd36c4240',
      /* 9.3 Response to the Signal to the same module in 2e */
      'c90e0c3f-d259-40ae-845f-6cb0a364e388': 'c677f8d6-7d68-4e2d-b73c-0711e7501213',
      /* 9.4 Signaling in Single-Celled Organisms to the same module in 2e */
      '1a3eb179-6a06-4a14-81bb-90fce075c39d': 'e578492c-f039-45ba-9fa0-a8fea0bf6920',
      /* 10.0 Introduction to the same module in 2e */
      '87a4423a-158e-40b8-86c5-a1bd14cf6584': '71297af1-7cfd-4c2a-b2da-089ca09d8ac9',
      /* 10.1 Cell Division to the same module in 2e */
      '4caf480f-6848-4231-9fe3-345bd87cae80': '0db21da7-2d98-4eba-9914-e71af15b8dd9',
      /* 10.2 The Cell Cycle to the same module in 2e */
      'd6d279e4-eb7a-4e64-8d53-8710b4c50e81': '49e53fad-66dd-43e6-a888-9b52c57d3ff2',
      /* 10.3 Control of the Cell Cycle to the same module in 2e */
      '69b8e2ee-f350-4202-8085-878c433e1cd5': '531843c3-6ffa-48be-8ae7-2db8e568cbb3',
      /* 10.4 Cancer and the Cell Cycle to the same module in 2e */
      '09866999-e751-4c08-b013-e46b93c08188': 'd5d83d52-c012-45dc-bf4e-78943d4cb3c2',
      /* 10.5 Prokaryotic Cell Division to the same module in 2e */
      '91c43929-51af-4cda-b1ba-ac8521bef464': '67f3a8e8-5941-4111-ac01-bcbce17c93a1',
      /* 11.0 Introduction to the same module in 2e */
      'a29864f3-11df-4ded-a481-b9ddeba0d407': '445d72d6-d903-4d37-8572-55fcf8ea715d',
      /* 11.1 The Process of Meiosis to the same module in 2e */
      '198652dc-30cf-4065-9bbf-80fe4e1f123b': '5b380d1e-9a27-4abf-9d1b-60c00411aca7',
      /* 11.2 Sexual Reproduction to the same module in 2e */
      '8fd39113-d8a6-4987-a41b-d0f4cea6062e': '0080ac75-30a9-4280-96f5-a3c9aa8ea868',
      /* 12.0 Introduction to the same module in 2e */
      '3b695749-395f-41f8-9cb3-13ea11c30a34': '3555a34f-b25d-4099-983b-422b02ab51a3',
      /* 12.1 Mendel's Experiments and the Laws of Probability to the same module in 2e */
      'c785a8d1-04ca-47ff-af0b-8de66795436a': '286c32e2-74db-42be-ab96-871faa273685',
      /* 12.2 Characteristics and Traits to the same module in 2e */
      'e2a834f2-7b7e-4ae4-bed8-f4d3c9fff598': '0fa42abc-7142-4581-9d01-d70f456ee71e',
      /* 12.3 Laws of Inheritance to the same module in 2e */
      '71479ebe-e682-4230-beab-d458bc170fe1': 'f197ede3-a02c-40e7-888e-1cde3d5e0028',
      /* 13.0 Introduction to the same module in 2e */
      '86f39385-c19c-4006-8c52-138cc6145958': 'fe9b70f8-1362-4c8e-88a5-b2848de32a8f',
      /* 13.1 Chromosomal Theory and Genetic Linkage to the same module in 2e */
      'a9d1d357-da72-47ee-8d93-4699f1da6244': 'd823be9f-2c63-46d3-a430-11322e011f76',
      /* 13.2 Chromosomal Basis of Inherited Disorders to the same module in 2e */
      '91f58935-5bef-40f2-88fd-8ef637648b9c': 'f618c969-8e72-4f0c-a40b-24ce780f500d',
      /* 14.0 Introduction to the same module in 2e */
      '434d46d6-6ce1-4709-96a7-e78e5477d4ee': '8c195463-825b-4c28-af6c-22a997e007c2',
      /* 14.1 Historical Basis of Modern Understanding to the same module in 2e */
      'edcd817b-eeae-4d6f-8cbb-5cc0430a8564': 'ab583fda-5cd4-40e0-beb6-981be9b48e61',
      /* 14.2 DNA Structure and Sequencing to the same module in 2e */
      '53bb4f0d-1c4a-4451-a97a-e24e2b9e7776': 'fcdf6aa8-82fd-440c-bf57-8306e21c03ef',
      /* 14.3 Basics of DNA Replication to the same module in 2e */
      '1723d815-cea1-4f32-891f-0373d7ef1137': 'f3ba4fa1-a1e1-4ae3-b89b-e5cc3a00eeb4',
      /* 14.4 DNA Replication in Prokaryotes to the same module in 2e */
      '34493d96-5fb7-4dd4-9ed4-6f476d2afa8f': '34c02409-fac3-425e-8c96-f8bc419679e7',
      /* 14.5 DNA Replication in Eukaryotes to the same module in 2e */
      'da5de7b1-f24a-4241-94ea-9740907f6bf9': '82ac346c-44a2-4256-b33f-b3f6c9386613',
      /* 14.6 DNA Repair to the same module in 2e */
      '30fcb950-c2a6-4dab-b62f-549c8ce3d7d1': '6fb1a22d-1761-4b60-9e61-7b538a681bff',
      /* 15.0 Introduction to the same module in 2e */
      'ecc98c47-ea58-4a61-ba67-76ffa037a28c': 'a298f528-7d7c-4885-839d-8c818ed91fac',
      /* 15.1 The Genetic Code to the same module in 2e */
      '40489b84-9322-47be-96dc-4f80079cb868': '6976329d-1584-4b4b-aa5a-a71437eb92cc',
      /* 15.2 Prokaryotic Transcription to the same module in 2e */
      '48fcec00-b861-4d5f-b1d3-1df6bbb80eb4': '3f1b97d6-823f-431d-a242-e34ca33628c1',
      /* 15.3 Eukaryotic Transcription to the same module in 2e */
      'ea5ef43f-dbba-447e-b163-d9dc09b49990': '12bf76de-bf6a-46ee-8320-2015bfe1f4b0',
      /* 15.4 RNA Processing in Eukaryotes to the same module in 2e */
      '8c2adf0b-96af-411c-9151-e53d9ce362b4': 'cf227884-a819-4f4b-bce3-3f331ddb0d49',
      /* 15.5 Ribosomes and Protein Synthesis to the same module in 2e */
      'd6603498-9a4c-4056-ac84-061ad4f8cdf9': '1ffcc036-2fbe-48b9-8b19-becb593cce28',
      /* 16.0 Introduction to the same module in 2e */
      '9a0de34f-fc57-4734-841e-78b9b4c3b7c8': 'ab9de637-4c00-4580-beb6-3776d618bc16',
      /* 16.1 Regulation of Gene Expression to the same module in 2e */
      '750579d3-02ef-4a96-8dee-bd9b11f7be6c': '43d8a9ec-64b8-44e9-8c82-e6a92a6fa823',
      /* 16.2 Prokaryotic Gene Regulation to the same module in 2e */
      '76b4a074-d223-4ad9-8d9e-4114c74f492c': '29c9e8e2-3df2-4a63-9d97-da0859b7385b',
      /* 16.3 Eukaryotic Epigenetic Gene Regulation to the same module in 2e */
      '112da94a-d347-4695-af35-9c97314f3e84': 'e5ccfc6d-f6f6-4e6a-8eea-e800685c6a4c',
      /* 16.4 Eukaryotic Transcription Gene Regulation to the same module in 2e */
      'ed1cb7a1-1b1e-4426-9e90-4c7ee7cd1841': '12648ecb-de5c-419b-a1a8-9b85d1274a1f',
      /* 16.5 Eukaryotic Post-transcriptional Gene Regulation to the same module in 2e */
      'c1fdc133-0975-40e0-8e97-d091e2960734': '73d3a24a-08bf-4c0b-b145-5f5a7f3b7248',
      /* 16.6 Eukaryotic Translational and Post-translational Gene Regulation to the same module in 2e */
      'f193c8c5-f472-43df-82b9-225103e22fd6': '7c43e668-da53-40b4-ae20-4bfe2a9ca9d1',
      /* 16.7 Cancer and Gene Regulation to the same module in 2e */
      '21b659c0-10cc-43be-a34e-e41db8d149f3': '2ede30b5-95cd-41de-8011-d1b5b0f33acc',
      /* 17.0 Introduction to the same module in 2e */
      '644feff4-c255-4063-811a-5104a2b430de': '615aef95-f20d-4552-aad0-fed21ea7448a',
      /* 17.1 Biotechnology to the same module in 2e */
      '7b18387b-8014-4514-b0fe-2dbef5e9d532': '0f4e391d-2040-40bd-a501-9113e83b3349',
      /* 17.2 Mapping Genomes to the same module in 2e */
      '42ae98d4-0d7a-4b6b-ba20-881b5e3be123': '1235fa6e-3a80-4a7d-a5e9-39470fe22d3b',
      /* 17.3 Whole-Genome Sequencing to the same module in 2e */
      'e65f38e1-9dfc-4da9-995c-f51db70d5abc': 'bc525e86-ee0b-49e2-8c80-8693f8b1a945',
      /* 17.4 Applying Genomics to the same module in 2e */
      '29cd41e7-21fb-499e-9929-353ee596dbbe': '25104c9d-d3bd-419a-b7d8-1df4b1b1d21a',
      /* 17.5 Genomics and Proteomics to the same module in 2e */
      '74a63fe7-167c-4666-a28e-1f634d43c6c0': '4f160c94-ec4f-4b94-beaf-84c0c1e9d38a',
      /* 18.0 Introduction to the same module in 2e */
      'b2589c4b-ef62-48a1-982a-724236ff26b5': '7b26324e-bb4f-4f76-9073-02333128e0b0',
      /* 18.1 Understanding Evolution to the same module in 2e */
      '9e805c7d-3865-4666-85ba-34c01660bf84': 'cc4e5e0d-9718-4021-b7eb-eb32c6dcdf45',
      /* 18.2 Formation of New Species to the same module in 2e */
      '977917b4-2c6e-4646-a100-636fa26717d4': 'b6fca77b-cea6-4dd9-aae3-eecf6c7db566',
      /* 18.3 Reconnection and Rates of Speciation to 18.3 Reconnection and Speciation Rates in 2e */
      '9d38a9c1-e81a-4cb7-8aa0-dae690bc4371': '58bf2e99-852c-4c37-a966-b3f0d818d40b',
      /* 19.0 Introduction to the same module in 2e */
      '38ad6783-a1f0-472e-8d3c-28cf336f1d3c': '9028cc49-1b0b-41cc-87ce-a9975727e188',
      /* 19.1 Population Evolution to the same module in 2e */
      '22277798-cbf5-46d5-8abd-9a50a79b2b54': '38be2b01-172f-49e0-862b-dbd191e63715',
      /* 19.2 Population Genetics to the same module in 2e */
      'c8d952c6-3d04-4c9f-b5dd-3c5350180468': '25fd74a6-7f4d-40d0-b2b4-89399e390346',
      /* 19.3 Adaptive Evolution to the same module in 2e */
      'fa528285-084b-478c-adc2-da78c46915ca': '137a241c-a086-40eb-9489-2c89abe7b99d',
      /* 20.0 Introduction to the same module in 2e */
      '5e2228c5-a640-42d4-8fec-2e8b668708d7': 'd53fc6fa-e29d-4d29-b8df-509b9ed845b2',
      /* 20.1 Organizing Life on Earth to the same module in 2e */
      '67322fde-a447-4caa-94f6-2c072d3bda66': '4bab9a65-c12d-4164-943f-c8d6d2d57963',
      /* 20.2 Determining Evolutionary Relationships to the same module in 2e */
      'b4e739c3-be08-4216-9e15-288ac678bb30': '991db4f1-55ea-465b-af03-de8ca2711813',
      /* 20.3 Perspectives on the Phylogenetic Tree to the same module in 2e */
      '275b6240-caa4-4937-94bb-eaeb86b2f34b': '1bc7e040-6cab-4840-a7e9-d3d68c49f683',
      /* 21.0 Introduction to the same module in 2e */
      'ed0fb5c2-ce30-4a76-8d58-77fb7cf9c7ec': '7bd5d488-478f-4934-8814-0807cde62962',
      /* 21.1 Viral Evolution, Morphology, and Classification to the same module in 2e */
      '78aa7335-3dd1-4dc4-bd12-f3dee2587553': '68c572c8-b391-4d8f-a27c-1fc47fa8c96b',
      /* 21.2 Virus Infections and Hosts to the same module in 2e */
      '7cbd15ad-5bff-4678-a99f-85fd579e070c': '19ba621e-246d-47ef-a400-803f83435433',
      /* 21.3 Prevention and Treatment of Viral Infections to the same module in 2e */
      'e0a7df01-1e56-47b2-81a1-95701e64b277': '47a969f6-d3ff-4744-9273-6b255dba10fb',
      /* 21.4 Other Acellular Entities: Prions and Viroids to the same module in 2e */
      'c7560d4a-bcd5-4739-83f4-3e44f44dc130': 'fb9a4dac-6ba6-4736-94f8-0dcc93709060',
      /* 22.0 Introduction to the same module in 2e */
      '2f332c42-3765-45dd-92a3-d1dfbe7678c1': '47a9884c-6501-4f80-8397-0e95e8668739',
      /* 22.1 Prokaryotic Diversity to the same module in 2e */
      'b94b96b8-c5fa-4bed-a047-97c324ffdc9d': '41b35c39-c3a6-4743-83ef-4ce42d5f4c59',
      /* 22.2 Structure of Prokaryotes to 22.2 Structure of Prokaryotes: Bacteria and Archaea in 2e */
      '9e7c7540-5794-4c31-917d-fce7e50ea6dd': '30d02dda-9af1-4a2a-92ac-e01a196f8594',
      /* 22.3 Prokaryotic Metabolism to the same module in 2e */
      '47cb544e-2d71-4962-8d42-87f00bad4045': '79cdd170-aace-447f-abf5-6c3e378f921d',
      /* 22.4 Bacterial Diseases in Humans to the same module in 2e */
      '0a866b1c-8f44-489a-ae8c-6e100ca0ee55': '58590575-c6c1-4963-8fd5-51baf0874dc0',
      /* 22.5 Beneficial Prokaryotes to the same module in 2e */
      'c839b5e3-3aa6-4855-a254-0a493ff1ad17': 'a61b7eb2-5ee2-4d68-8d53-9d71e9610906',
      /* 23.0 Introduction to the same module in 2e */
      '2d9e50a6-fddc-4a36-8b85-609879ff3c32': '59ad01ae-1732-4089-91b1-20f0ebf56c0a',
      /* 23.1 Eukaryotic Origins to the same module in 2e */
      'a0746ee5-d512-4fe7-91ba-91649630ca0c': '6e4811fc-f92e-4a16-8388-8b411b25436d',
      /* 23.2 Characteristics of Protists to the same module in 2e */
      '1e2d9bb8-0150-48c6-909e-1501c626c11b': '189a0a8d-44cc-41b5-a749-17636bd42586',
      /* 23.3 Groups of Protists to the same module in 2e */
      '1e968d8c-f2be-41e8-9610-3bff97d4d373': 'ae29ec58-662a-4144-8f27-ec852e22cc64',
      /* 23.4 Ecology of Protists to the same module in 2e */
      'd668ad34-2c26-45db-9fc7-95e3cbfc0149': '624c0bda-6b06-481f-9c8f-335d636fac63',
      /* 24.0 Introduction to the same module in 2e */
      'ed9fa295-e334-4650-b81d-0ede564fb71f': 'bc079de6-f6e4-4064-a3ca-82c0aed4642d',
      /* 24.1 Characteristics of Fungi to the same module in 2e */
      'fa5f3021-e491-4c4d-bd3b-9b99bc75b3c9': 'e6e6d554-c6a4-4660-a416-06f6eee81640',
      /* 24.2 Classifications of Fungi to the same module in 2e */
      '0137fd51-7ed5-44de-b9a8-41c9311dcd3f': 'da51df1d-80d8-41f8-81fc-31cb99c71407',
      /* 24.3 Ecology of Fungi to the same module in 2e */
      '54faf509-a2ed-414d-8885-02445499420e': 'e9ab5805-ee8e-451e-9897-90cc291c655c',
      /* 24.4 Fungal Parasites and Pathogens to the same module in 2e */
      'b81e6e0d-428f-4e3e-933f-c5e85ff4cad0': 'c0fb29c2-5990-49ab-b988-b4ffe31ccf75',
      /* 24.5 Importance of Fungi in Human Life to the same module in 2e */
      '3f0c5f6b-e799-46d8-85c2-b416e19bc880': '8d50a0af-948b-4204-a71d-4826cba765b8',
      /* 25.0 Introduction to the same module in 2e */
      '204fed82-9cb3-41b3-b278-b117d2a7c1aa': '89e115d8-4f9c-4252-a015-1eda6accd341',
      /* 25.1 Early Plant Life to the same module in 2e */
      'b12983b8-a6da-46f6-9873-7f9d5776b9ec': 'a5a65a50-9ba8-4f5d-bbef-0875f56d9884',
      /* 25.2 Green Algae: Precursors of Land Plants to the same module in 2e */
      '5ff37d64-d2f7-44e3-8444-f0e63d5979cf': 'ee21a512-94cb-4665-89d6-ae9e0484ccfb',
      /* 25.3 Bryophytes to the same module in 2e */
      '1c7d3088-26b5-430a-a41d-1232a353e595': '8d50a0af-948b-4204-a71d-4826cba765b8',
      /* 25.4 Seedless Vascular Plants to the same module in 2e */
      'e06bde91-e72c-46d4-85e4-08096675957e': '7e97e09d-8c26-473b-9118-9cbe049aaa97',
      /* 26.0 Introduction to the same module in 2e */
      '07323435-7692-4d81-a44d-4c4250c37c8e': '57b3a601-2831-44b7-961b-71085b7273f2',
      /* 26.1 Evolution of Seed Plants to the same module in 2e */
      '1c45a66a-7a23-48ef-9948-8ae39ee01eb4': 'f939e91c-cce9-4365-96d3-496182c0172b',
      /* 26.2 Gymnosperms to the same module in 2e */
      'b4bc502e-4b01-4832-be25-90b16239f1dd': '8338d90b-bc64-4c57-b0f9-a6d39bc50bea',
      /* 26.3 Angiosperms to the same module in 2e */
      'b3298ec7-b55c-4ce7-89fd-1d4fad39630f': '38d74f83-c1d3-47cf-8b81-2bf05959a5d6',
      /* 26.4 The Role of Seed Plants to the same module in 2e */
      'b3e7f392-d140-4ab4-b49b-d12c0e89c1a1': '5fc960c9-5e4e-43bb-9e1e-ed7354c2835e',
      /* 27.0 Introduction to the same module in 2e */
      '582b3b99-c003-4538-8965-2375382204ee': 'a16c2ade-ef04-4ead-b2fc-73da91de3930',
      /* 27.1 Features of the Animal Kingdom to the same module in 2e */
      'd09cbd3e-a293-4aab-9ae6-e1a46e9e1da9': '28e097ee-a250-43e6-ba9f-e423a7ebd416',
      /* 27.2 Features Used to Classify Animals to the same module in 2e */
      '7289a2d7-803c-49ef-905a-01324d155936': 'dc001ce9-dbe7-4f22-beeb-a0cda8717b4c',
      /* 27.3 Animal Phylogeny to the same module in 2e */
      '0b4f514a-f4d4-455a-8814-97fa5df05345': '97046149-9e72-41df-9437-6e8bc9e33af4',
      /* 27.4 The Evolutionary History of the Animal Kingdom to the same module in 2e */
      '0a0b301a-b084-4d30-82d5-430c4d266f35': '90806b4e-9f58-43f6-88ea-7d4c31814cf0',
      /* 28.0 Introduction to the same module in 2e */
      '11247285-083e-4281-ba13-20a70d0377d8': '4c18e62b-2227-4026-a92f-90f102c4e3b3',
      /* 28.1 Phylum Porifera to the same module in 2e */
      'bb72c222-96b6-4e61-828b-0a667ec1ef22': 'b0d8ecc1-f44f-4835-9837-92858a8391c7',
      /* 28.2 Phylum Cnidaria to the same module in 2e */
      'a7777b21-e8d8-4e7f-a40f-5d3fdf86b904': 'ed5a58c0-eb7e-4402-8491-2f67cb3b065b',
      /* 28.3 Superphylum Lophotrochozoa to 28.3 Superphylum Lophotrochozoa: Flatworms, Rotifers, and Nemerteans in 2e */
      'd1219426-4d63-40e3-83b4-dc367df7b1fa': '6eccffcf-18b5-4e01-8490-dfc07acef7b9',
      /* 28.4 Superphylum Ecdysozoa to 28.5 Superphylum Ecdysozoa: Nematodes and Tardigrades in 2e */
      '39403bd7-2528-49f8-b59d-c9ac37663e15': '55559642-e440-49b3-9ec7-59dc8914ea53',
      /* 28.5 Superphylum Deuterostomia to 28.7 Superphylum Deuterostomia in 2e */
      '88c2f090-b457-4f4e-9b9a-bce5949481e2': 'bfad021f-7388-4d46-ab94-77a62255130e',
      /* 29.0 Introduction to the same module in 2e */
      'ce4b10f1-479c-47df-8da1-874637759176': 'b49a0d13-c3b3-46e5-a0f1-074ef9836fd5',
      /* 29.1 Chordates to the same module in 2e */
      '541db286-b021-462f-84f6-0d8540de9314': '6e0ce1c0-316b-42e8-bcf4-03ec2330d814',
      /* 29.2 Fishes to the same module in 2e */
      '856f19b8-cb2d-40b4-b9f7-b466c13045cd': '74a306c1-c3cb-4ad2-ad66-27b2230e0e0c',
      /* 29.3 Amphibians to the same module in 2e */
      '4c8391c9-f95a-4309-857a-840275fe776b': '3ad996b0-7066-4eb0-b5e5-625dc8e5c6d7',
      /* 29.4 Reptiles to the same module in 2e */
      '7c002ad9-7046-4631-ae85-192159967cab': 'd1d2bdfe-3f38-4cdd-bde0-b223a2f3a7fe',
      /* 29.5 Birds to the same module in 2e */
      '16822841-8449-434a-a45f-9e1633044c32': '43e12a86-6567-4638-ad39-dd2272e85f40',
      /* 29.6 Mammals to the same module in 2e */
      'a7a48cd6-4931-4e0c-8499-9bb42411f0c5': '063053ea-9fb3-48ab-b10d-b7d837d730f5',
      /* 29.7 The Evolution of Primates to the same module in 2e */
      '27ad04dc-d4c0-4fe1-af9c-cb65128de719': '112cfa1a-5875-4fb6-a870-c71c74409adb',
      /* 30.0 Introduction to the same module in 2e */
      '8cfff5fa-6a5f-491c-a768-44929964104d': '64746996-0485-4e22-8de2-2d466ecd874c',
      /* 30.1 The Plant Body to the same module in 2e */
      'cd0fea74-368e-4015-ae27-e41b3d893b36': 'c0dbd70d-e697-4fef-8050-57d35700687e',
      /* 30.2 Stems to the same module in 2e */
      '135eeaa9-79a4-4d8d-af7d-a0b6cf9e22d6': '04fafa36-12fb-4e07-a187-ebf222c24816',
      /* 30.3 Roots to the same module in 2e */
      'addad899-ddc7-489f-918a-30ff0b88911b': '2f03c299-5283-4dd6-af7d-c4d1f09e97ed',
      /* 30.4 Leaves to the same module in 2e */
      'b9423ada-def0-4c06-98b2-5b59c5d07596': '3757f47b-b84f-4226-a34f-09f1e3918f54',
      /* 30.5 Transport of Water and Solutes in Plants to the same module in 2e */
      'e5aabc6f-71d9-40d5-99f0-0fb2d8d47317': 'b925c240-047c-4f5f-bcbb-b49ba13dd268',
      /* 30.6 Plant Sensory Systems and Responses to the same module in 2e */
      'c63b7f28-16a2-4602-b996-cdc7eb78219b': '7a273bb3-9d29-48df-9505-f84f3ae3bac1',
      /* 31.0 Introduction to the same module in 2e */
      '349efd3e-f7ce-43cd-8b7b-98424310a985': '31c32b5b-48ad-4b2c-b44c-aa8981630394',
      /* 31.1 Nutritional Requirements of Plants to the same module in 2e */
      '57874cae-4b45-4edf-af71-f5df36ec4eb9': '686bc1e6-9010-4523-826d-2a225701c3c8',
      /* 31.2 The Soil to the same module in 2e */
      '3ceada67-61b1-478f-9aaf-604f5f34d116': 'b6d33d57-6ccf-4744-b68c-58bc99cb77d9',
      /* 31.3 Nutritional Adaptations of Plants to the same module in 2e */
      'bb913977-c624-45ce-99f2-425cb520b807': '374df612-250b-4d07-ad19-5cff800e064d',
      /* 32.0 Introduction to the same module in 2e */
      'baffdcc7-0c68-416f-996e-0aa99cf96a5d': '86537fe1-c159-4e57-9993-3d05630d3afe',
      /* 32.1 Reproductive Development and Structure to the same module in 2e */
      'f4f12383-bcdd-4ea4-a192-96a8f307e07f': '48c67b7f-26a8-41cd-b3ac-cf82a9c775fa',
      /* 32.2 Pollination and Fertilization to the same module in 2e */
      '4cb8905e-544e-4dc7-98ed-0889d3a4981a': '3a0feddf-3c2f-4505-a389-96e2d7ec2f9a',
      /* 32.3 Asexual Reproduction to the same module in 2e */
      '32be2767-4952-4dba-a93f-5fb6593e3fd6': '9ef012df-303f-4adc-b64d-cebbec144778',
      /* 33.0 Introduction to the same module in 2e */
      '60a1d14d-c74f-473c-a94b-029b4a704a35': '40df8737-440f-4d88-b876-215e0eaa60b9',
      /* 33.1 Animal Form and Function to the same module in 2e */
      '44503b54-9a4c-40c4-ae59-369526d2f9ef': 'b1835f27-ca0d-4590-a977-a98c5218af75',
      /* 33.2 Animal Primary Tissues to the same module in 2e */
      'f8b7e159-1112-46ea-be19-5f492747a7b5': '4d052232-38e7-485d-b770-409ebc56cf5b',
      /* 33.3 Homeostasis to the same module in 2e */
      '04fdb865-17a1-43d8-bb33-36f821ddd119': '03f71a95-9021-4030-85b8-acaa56e8c2b9',
      /* 34.0 Introduction to the same module in 2e */
      '41fb680f-b781-4e9a-a393-76ca49c55ff9': '7a1a2a26-bb84-409d-816a-a2270adf0e50',
      /* 34.1 Digestive Systems to the same module in 2e */
      '39eb2d7f-4604-401d-a5ed-ca159c04cc80': 'dc93764f-bc4a-4c3b-abea-bc59581e6474',
      /* 34.2 Nutrition and Energy Production to the same module in 2e */
      '717906af-34be-4e1d-917d-e0e24bfc0901': '14b0b3ec-81d1-4caa-8694-9fbb5892ee2e',
      /* 34.3 Digestive System Processes to the same module in 2e */
      'f4dc9545-9398-417d-bb23-249fc9892cac': 'b85d2fad-d616-4795-b0f1-d27dc100fbca',
      /* 34.4 Digestive System Regulation to the same module in 2e */
      'd8bc0f62-79c7-4777-bf95-3d94eeca7a1a': 'e204ddb5-6b0b-4f59-a04b-267723dbdbd5',
      /* 35.0 Introduction to the same module in 2e */
      '6dfe867e-6b08-47f3-a5f1-6bce3259ecb4': '356b7818-0312-4c31-b7e3-8e28572cb910',
      /* 35.1 Neruons and Gilial Cells to 35.1 Neruons and Glial Cells in 2e */
      '73d8f8a7-46a3-4a3a-9afa-970f2f03deb3': 'd298b074-d6b3-4356-af3d-a2e91236f5af',
      /* 35.2 How Neurons Communicate to the same module in 2e */
      '72cfcf6f-e196-4e0b-9bcf-45f4853993e4': '2970bff8-c681-443d-ae33-ede7245d65d9',
      /* 35.3 The Central Nervous System to the same module in 2e */
      '24e8609c-16a7-4dd5-b3da-e38aaeef7ed5': 'a240ebbd-1104-4cf5-bd36-e0d93160f4d8',
      /* 35.4 The Peripheral Nervous System to the same module in 2e */
      '56a8c532-664f-4ad7-8edf-2305d723be10': 'a37e172d-51fe-49d5-aae4-82f5f0afc3d7',
      /* 35.5 Nervous System Disorders to the same module in 2e */
      'c1f66449-457f-401a-bac3-12c65da2779a': '74b2b63f-d483-47b4-8345-24ece27acd15',
      /* 36.0 Introduction to the same module in 2e */
      'bab1b85e-198a-4bb6-b801-c8d543f17f6e': '10b6f4f4-ca3b-44f7-a8ca-c6cb11d46c05',
      /* 36.1 Sensory Processes to the same module in 2e */
      'e9f97e0d-10ae-43ec-9062-5f0079dfd57f': 'fa509e9d-eb29-4fc4-807b-a7efc7c469d4',
      /* 36.2 Somatosensation  to the same module in 2e */
      'b32f61fc-5fab-4b07-bcc8-e455aa4a903d': 'e0bf2f78-fa72-4be5-9886-5c94a027767d',
      /* 36.3 Taste and Smell to the same module in 2e */
      'e6739dc0-2ea2-41ef-af28-61c53e04dbb0': 'c49ec3cf-18fd-4945-904e-c646a269ba41',
      /* 36.4 Hearing and Vestibular Sensation to the same module in 2e */
      '45f94050-f136-4699-9779-b2953173b7bf': '05615552-34e6-4f9b-8f40-52196dc37729',
      /* 36.5 Vision to the same module in 2e */
      '7efc0079-6e04-4ea9-a39c-6551121b9dd1': 'e9648b38-f273-428f-ab4f-ed1f4392a1ae',
      /* 37.0 Introduction to the same module in 2e */
      '44398b9a-c25b-4e06-9352-feeac13dfad4': '5d3e8c71-b7e3-4609-a8bd-79c77ebacdad',
      /* 37.1 Types of Hormones to the same module in 2e */
      '9970356c-0383-482a-a13e-9e4fdbfc8917': 'ac25e223-cea5-4266-a5ef-539739c77ce5',
      /* 37.2 How Hormones Work to the same module in 2e */
      'cbe4c6ff-348e-4383-ae66-f6fa19823b6c': '0c8d472f-820e-4a80-b8a0-09c159d29651',
      /* 37.3 Regulation of Body Processes to the same module in 2e */
      'a0d22048-c0b6-4b2b-abf1-1a3e61ada97d': '4cb3e405-2aad-4648-bb58-f20c71df0bcc',
      /* 37.4 Regulation of Hormone Production to the same module in 2e */
      '0e09d3f8-790c-42fe-acb3-a7020c1eebe4': '9d3b9c3b-c37c-459c-8a5a-e95bb13ab02d',
      /* 37.5 Endocrine Glands to the same module in 2e */
      'a708d3cb-ec37-4cbb-a945-e0b5fb0be2fa': 'd7b5e71d-64e9-4a3b-b97f-66c212c9ed0d',
      /* 38.0 Introduction to the same module in 2e */
      '58ed7aec-ef1b-4c9c-bb2c-8ef972188acb': '23a29c64-12f2-40a3-ae78-ce6484903cbc',
      /* 38.1 Types of Skeletal Systems to the same module in 2e */
      'b30d4eb7-6be4-4db2-b8c9-20256add53f5': 'e1d6b94a-4cfe-41fa-9119-c858d53f12b6',
      /* 38.2 Bone to the same module in 2e */
      'aa6ac9bb-ae22-47f2-8dbf-608fc90dd3b4': 'facbc50c-daac-4639-aa2b-fb55cd6cdf78',
      /* 38.3 Joints and Skeletal Movement to the same module in 2e */
      'f3a5c924-6b1b-4d1b-b506-906b00da0be5': '5abd8e4e-7b52-4bdf-8444-f42ee617b8c1',
      /* 38.4 Muscle Contraction and Locomotion to the same module in 2e */
      'b7c9b702-b46c-435e-bea3-eee85ed940b4': 'f64a4c80-c813-4d2e-9682-38b54b5d947b',
      /* 39.0 Introduction to the same module in 2e */
      '11c269b9-1f41-4e45-b6c6-b8dc7275b5f7': '802ad73d-07be-4326-a73c-94227921c142',
      /* 39.1 Systems of Gas Exchange to the same module in 2e */
      'df9f91d1-b8aa-45f9-9d13-50913bf95614': '9b635f68-000d-4034-979d-bdfadaf9107f',
      /* 39.2 Gas Exchange across Respiratory Surfaces to the same module in 2e */
      '079215a1-b957-465f-bb1e-2393dcfe8915': '0e7a41a1-3b19-461c-9168-5eaad8185a8f',
      /* 39.3 Breathing to the same module in 2e */
      '1388be61-0219-4b08-b6d6-b3c7396b5fa3': '4daa8e5b-71bc-42c2-8229-9c5344bc0ff4',
      /* 39.4 Transport of Gases in Human Bodily Fluids to the same module in 2e */
      'b241186c-4978-4904-ad7b-43e06974d549': '2d3e0408-9a20-4e31-8b2f-97805b677c1d',
      /* 40.0 Introduction to the same module in 2e */
      '69577d07-ed4b-46ca-8f63-f99d08d0f8da': 'd3f4fb23-541c-4def-90c6-9f442e82bd78',
      /* 40.1 Overview of the Circulatory System to the same module in 2e */
      '599f6b13-33a3-4c76-908d-03c0f998d143': '819c00cf-312c-448e-8bbd-f1aaac5167e8',
      /* 40.2 Components of the Blood to the same module in 2e */
      'fd78a9c0-a232-4b11-b3a3-ab6955731177': 'b6861acf-64e9-469a-aed0-8142170f2baf',
      /* 40.3 Mammalian Heart and Blood Vessels to the same module in 2e */
      '65d0b611-6bb3-47ae-84c2-471fb52ba148': 'b0c0b424-8c51-415a-b656-757651499f69',
      /* 40.4 Blood Flow and Blood Pressure Regulation to the same module in 2e */
      '607aff2b-b38c-47f2-8baa-b046cc7c6d85': '3a261452-008b-44fa-bf5b-9af010176cbf',
      /* 41.0 Introduction to the same module in 2e */
      '80b07b39-b117-406c-aa18-d5f82ce7ed86': '0709b4f0-956a-4faa-892c-bd8af2f99f40',
      /* 41.1 Osmoregulation and Osmotic Balance to the same module in 2e */
      'd9b33f1c-23c0-46d3-8606-be1df10ccb63': '0c1b88cb-ecfd-4626-a23e-a2c1eed96535',
      /* 41.2 The Kidneys and Osmoregulatory Organs to the same module in 2e */
      '3e2c416b-efb4-4386-a1ca-f18fb7b83ec5': '3717dbea-6bde-4ac2-9577-3383b7fea42d',
      /* 41.3 Excretion Systems to the same module in 2e */
      'a91a79a8-fad7-4fd5-a500-8db68ae7ad8c': '21d313cb-dd5a-4076-8863-f531731a35d0',
      /* 41.4 Nitrogenous Wastes to the same module in 2e */
      '74427621-5991-4457-a80a-bc6b2edd4896': 'db6c2bae-aae9-46d6-9910-6f35c3860567',
      /* 41.5 Hormonal Control of Osmoregulatory Functions to the same module in 2e */
      '9e7345a6-ff4a-4839-b05c-8c3f580aa32c': 'eca3d2ee-e729-4849-b680-fb1168c52a2e',
      /* 42.0 Introduction to the same module in 2e */
      'cefec3f8-777e-4951-9b70-abf9d346b923': '393b6727-40d1-4e88-a6b9-63c2cb123bef',
      /* 42.1 Innate Immune Response to the same module in 2e */
      '5da10a86-3129-460c-b5b6-0a40c00b9969': 'b9af4731-9805-4b3c-abca-f604af5aff5e',
      /* 42.2 Adaptive Immune Response to the same module in 2e */
      '7ad6686e-c53e-45bb-aaa2-15327dff8d3e': 'ddbbb44d-037d-4398-9e7c-ed069a52ccc3',
      /* 42.3 Antibodies to the same module in 2e */
      '01be6158-869f-44d1-83ea-a2ce64d85ef1': '8cdd46dc-4f4b-465f-9cb2-cf2dd0357a5a',
      /* 42.4 Disruptions in the Immune System to the same module in 2e */
      'da9ed27d-8460-4964-9344-40a7c3901d29': 'b9f75abe-b959-4bd5-8d29-4d3742779658',
      /* 43.0 Introduction to the same module in 2e */
      '1fc80d68-43c6-4a05-91a5-b839efdf2fa1': '949773f7-f0f3-4ec0-94a5-e1e9ada6de28',
      /* 43.1 Reproduction Methods to the same module in 2e */
      '3127134b-36a5-4489-adea-3cc50af1305a': '60c79c14-824a-4d20-9aed-9dcd278bdeda',
      /* 43.2 Fertilization to the same module in 2e */
      '9b69aa5d-16fa-4604-a26b-e92f9ecd9bc0': '3b9b3c04-f15e-4b07-ae7b-8c9c3fe87755',
      /* 43.3 Human Reproductive Anatomy and Gametogenesis to the same module in 2e */
      '07f97982-30d2-425e-8a82-542e6fdd666e': '880b32e2-b463-4fb1-aeda-6a23669d2ace',
      /* 43.4 Hormonal Control of Human Reproduction to the same module in 2e */
      '1daddd9c-5131-4979-a7d5-a8183fca0ad8': 'c1288cd5-1a34-410c-aeb5-fa329e437f8e',
      /* 43.5 Human Pregnancy and Birth to the same module in 2e */
      '3422a2b7-9dee-4e6b-93b5-3f1fc92e88b9': '2c34b0e7-0383-4a6c-9ce4-0dc1c3cea8ff',
      /* 43.6 Fertilization and Early Embryonic Development to the same module in 2e */
      'c8105eac-93c4-43e8-83f1-54995429e8ca': '8d50a0af-948b-4204-a71d-4826cba765b8',
      /* 43.7 Organogenesis and Vertebrate Formation to the same module in 2e */
      '68ae7446-32b4-4cc7-89a7-4615dd20f3bd': '9b4b8901-689f-4dee-a00b-826d8f9f32f1',
      /* 44.0 Introduction to the same module in 2e */
      'c49b257a-c9b1-4e3f-bc9b-a1b080801af3': '3a4c0adc-2154-4447-a60d-95a14913ebf4',
      /* 44.1 The Scope of Ecology to the same module in 2e */
      '10d9c46e-990f-4404-b7af-802b5b4e0fa6': '32deb145-a903-44d6-8d1e-45adff7d0946',
      /* 44.2 Biogeography to the same module in 2e */
      '405e3804-5c8c-4f00-9dce-06b279ac4f53': 'fec0b92c-d1e2-46cc-92ec-21af0efa8953',
      /* 44.3 Terrestrial Biomes to the same module in 2e */
      'cf87c2b7-d8ec-4cba-adba-6c30f5736f63': 'c6226ee3-8e2e-4db9-841b-92a1726af4ef',
      /* 44.4 Aquatic Biomes to the same module in 2e */
      '4552b33e-01c6-487b-81da-7f630a9a4298': 'aa4e2af2-4298-4ebc-b231-e28971619dbe',
      /* 44.5 Climate and the Effects of Global Climate Change to the same module in 2e */
      'a1fb54b1-a560-4093-b4fc-277409b3b43b': '3ae1b409-66ed-4c63-82ed-2522fb095efc',
      /* 45.0 Introduction to the same module in 2e */
      'd193fe8a-8026-4c62-bee4-e977c6de7989': 'f1b7e026-9ebf-4115-a1f6-f3c4ef365e21',
      /* 45.1 Population Demography to the same module in 2e */
      '36b59ccb-df39-4ba6-85cc-52f3042c36ab': '50d5b660-667d-4051-86f0-d3735751147c',
      /* 45.2 Life HIstories and Natural Selection to the same module in 2e */
      '04046ffb-73f6-4ccf-815d-e94697bab6fd': '1a7c3e88-d8d9-4a07-96df-03f11c793655',
      /* 45.3 Environmental Limits to Population Growth to the same module in 2e */
      '79ebaf1a-0e1a-4efb-9712-9bb41919a17d': '9b5c5687-2c4f-4ce7-8f04-511d00ec2a29',
      /* 45.4 Population Dynamics and Regulation to the same module in 2e */
      'bd8d993b-f105-4122-80ef-83d1dcfacde2': '2ca2c793-cfda-45e7-bd68-771bea4e1cf6',
      /* 45.5 Human Population Growth to the same module in 2e */
      '9bf55f5c-6f4b-40d8-bc99-873d021291c3': '92d9fb38-6b5a-4d82-a2e3-1923d2d52f4e',
      /* 45.6 Community Ecology to the same module in 2e */
      '774c6097-22c3-4621-a29f-62bb9d77d47e': 'd856d831-d708-41d0-afd2-8dfe51cec7c2',
      /* 45.7 Behavioral Biology: Proximate and Ultimate Causes of Behavior to the same module in 2e */
      '98dc9ab6-4f77-4f2e-85fb-c69c97c68649': '385718d4-c4a8-4cb7-9c9e-05c05fa1c693',
      /* 46.0 Introduction to the same module in 2e */
      '76221989-258f-44ce-a9cd-77a3f8494bbc': '0982eab8-014c-47d6-b452-32f193308fe4',
      /* 46.1 Ecology of Ecosystems to the same module in 2e */
      '5f31b7ed-13e0-4a64-93b2-d1bb73a3e022': 'e009296e-b643-47f4-98d0-d3af8fd3cdbf',
      /* 46.2 Energy Flow through Ecosystems to the same module in 2e */
      'c96960a6-68ef-4834-b36d-2abc00a61619': 'a095764b-dd69-4f89-a4c5-537842828d19',
      /* 46.3 Biogeochemical Cycles to the same module in 2e */
      '65d16444-425c-4f43-bc48-a3d0de0c2fbd': '9ad7612b-f0a1-4d0a-ad7b-be420d671b01',
      /* 47.0 Introduction to the same module in 2e */
      'c0d58dad-90b4-4861-a66e-c4d495949899': '1db1add0-9362-4e0f-93f8-525ea3d6d20b',
      /* 47.1 The Biodiversity Crisis to the same module in 2e */
      '96f938e3-f5b1-46bc-9665-79d3a607d9e7': 'da08205e-4d79-4285-ada3-60fedbb6ab2e',
      /* 47.2 The Importance of Biodiversity to Human Life to the same module in 2e */
      '773fc1ea-e2b8-4f5e-ade9-9b17d5b1d2b6': '2be0f134-0ef9-4a25-a6aa-efb7bb99d1bb',
      /* 47.3 Threats to Biodiversity to the same module in 2e */
      'ef12a7d2-c569-4f8b-833c-595454102c1a': '8bc8eaa2-e79c-4347-9521-a797be518a7f',
      /* 47.4 Preserving Biodiversity to the same module in 2e */
      'aaf2ab73-1c53-4518-9a03-63e238421f59': '0f8688d8-b025-4e07-a37b-ac12b85399ba',
      /* Periodic Table of Elements to the same module in 2e */
      '85876150-cd23-42ac-ab49-a6002a43a5c8': '1094eff5-9302-4bf4-b599-3cb3703642d6',
      /* Geological Time to the same module in 2e */
      'aebd6cfc-39e6-4b33-ad78-604d5de78dfd': '7f9cdc1f-a1a3-4353-9fa4-901681da97dc',
      /* Measurements and the Metric System to the same module in 2e */
      'fa9fa6f3-941c-45b2-927b-4a0ae10b0e07': '461abba6-4236-4913-9ab4-17328dcda078',
    }],
  ],
} as CanonicalBookMap;
